<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-go`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.43311 11.9697C8.69276 12.2291 9.11487 12.2292 9.37451 11.9697L12.8745 8.46973C13.1341 8.2101 13.134 7.78804 12.8745 7.52832L9.37451 4.02832C9.11481 3.76862 8.6928 3.76862 8.43311 4.02832C8.17359 4.28803 8.17347 4.71009 8.43311 4.96973L10.7974 7.33398L3.59521 7.33398C3.22795 7.33398 2.93018 7.63175 2.93018 7.99902C2.93039 8.36611 3.22808 8.66406 3.59521 8.66406H10.7974L8.43311 11.0283C8.17359 11.288 8.17347 11.7101 8.43311 11.9697Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineGo',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
